import { comparisonData } from "@/mocks/home";

export default function ComparisonTable() {
  return (
    <section id="safety" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Superbuy Spreadsheet vs <span className="text-primary-500">Random Sellers</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            See the difference between using a verified spreadsheet and buying from random sellers
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-foreground-100/40">
                  <th className="text-left py-4 px-5 font-semibold text-foreground-950">Feature</th>
                  <th className="text-left py-4 px-5 font-semibold text-accent-700">
                    <span className="inline-flex items-center gap-2">
                      <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                      Superbuy Spreadsheet
                    </span>
                  </th>
                  <th className="text-left py-4 px-5 font-semibold text-foreground-500">
                    <span className="inline-flex items-center gap-2">
                      <span className="w-2 h-2 rounded-full bg-foreground-300"></span>
                      Random Sellers
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, i) => (
                  <tr key={row.feature} className={`border-b border-foreground-100/20 ${i % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}`}>
                    <td className="py-4 px-5 font-medium text-foreground-800">{row.feature}</td>
                    <td className="py-4 px-5">
                      <span className="inline-flex items-center gap-1.5 text-accent-700 font-medium">
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-check-line text-accent-500"></i>
                        </span>
                        {row.spreadsheet}
                      </span>
                    </td>
                    <td className="py-4 px-5 text-foreground-500">{row.random}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}